import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import * as filters from "./filters";

import store from "./store/";
import './sass/global.sass'
import './assets/sass/font.sass'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
